import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericSelect } from '../../components';
import { InputModelWithSource } from '../../models';
import { InputWithSource } from '../../componentTypes';

const HeadlineLossInput: InputWithSource = ({ input }) => <GenericSelect label={input.name} input={input} />;

HeadlineLossInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(HeadlineLossInput);
